import React, { ReactNode } from 'react';

import { TouchableWithoutFeedback, ViewProps } from 'react-native';

import { Container, NakedIcon, VectorIconProps } from 'theme';
import { ViewStyleProps } from 'theme/layout';
import { Colors } from 'theme/colors';

import { Card, CardText, CardIcon, CardNext } from './styles';

const CTA_NEXT_ICON_SIZE = 7.5;

/**
 * The component used to specify the CtaCard's image. It ensures that the image is the correct size to work with CtaCard
 *
 * @param props - the properties of the icon
 */
export function CtaIcon(props: VectorIconProps) {
  return <CardIcon size={48} color={Colors.green} {...props} />;
}
/**
 * A card styled as a call to action. It includes an icon, text, click and hover styles.
 *
 * @param props - the properties for this component
 */
export function CtaCard(props: CtaCardProps) {
  const { onPress, icon, text, ...remainingProps } = props;
  const arrowStrokeStyle = {
    // '-webkit-text-stroke-width': 'medium',
    WebkitTextStrokeWidth: 'medium',
  };

  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <Card
        display="flex"
        flexDirection="row"
        overflow="hidden"
        alignItems="center"
        {...remainingProps}
        height={['80px']}
      >
        <Container
          position="relative"
          height="48px"
          minWidth="80px"
          margin={['16px 24px 16px 24px']}
        >
          {icon}
        </Container>
        <CardText display="flex" flexDirection="row" alignItems="center" flexGrow={1}>
          {text}
        </CardText>
        <Container
          display="flex"
          flexDirection="row"
          alignItems="center"
          position="relative"
          flexGrow={0}
          margin={['24px 24px 24px 16px']}
        >
          <CardNext>
            <NakedIcon
              style={arrowStrokeStyle}
              size={CTA_NEXT_ICON_SIZE}
              color={Colors.black}
              name="arrow-right"
            />
          </CardNext>
        </Container>
      </Card>
    </TouchableWithoutFeedback>
  );
}
/** Properties used by CtaCard */
export interface CtaCardProps extends ViewProps, ViewStyleProps {
  // the function to call when this component is clicked/pressed
  onPress: () => void;
  // the background icon to display in the call to action
  icon: ReactNode;
  // the text to display in the call to action
  text: string;
}
